/* @flow */
import { Request } from "shared/src/services/Requests";
const RequestBuilder = new Request.Builder("evaluate", "article");

export type Params = {
    countryCode: string;
    locale: string;
    articleId: string;
    storeId: string;
    customerId: string;
    isCustomer: boolean;
};

export const SubstitutesClient = {
    getSubstitutes({ countryCode, locale, articleId, storeId, customerId, isCustomer }: Params) {
        const template = "/substitutes/{country}/{locale}/{id}/{storeId}";
        const pathParams = {
            country: countryCode.toUpperCase(),
            locale,
            id: articleId,
            storeId
        };
        const queryParams = {
            customerId,
            assortmentRange: isCustomer ? "FSD" : "EMPLOYEE"
        };
        return RequestBuilder.path(template, pathParams).query(queryParams).get();
    }
};
